import { TextDrawer, validTypes } from "./TextDrawer";
export async function loadTextShape(engine) {
  let refresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  await engine.addShape(validTypes, new TextDrawer(), refresh);
}